import { LocaleDictionary } from 'src/locales/LocaleDictionary'

/**
 * Localized strings for the British English (en-gb) locale.
 */
export const dictionary: LocaleDictionary = {
  pageLayout: {
    footer: {
      localeSwitcher: {
        localeListAriaLabel: 'Select language',
      },
    },
  },
  components: {
    CtaPopup: {
      closeButtonAriaLabel: 'Close',
    },
    EventCountdown: {
      days: 'Days',
      hours: 'Hours',
      minutes: 'Min',
      seconds: 'Sec',
    },
    SearchableFaq: {
      displayAllCategoriesButtonLabel: 'All',
      searchInputAriaLabel: 'Search FAQ',
      searchInputPlaceholder: 'Search FAQ...',
      emptySearchResultsMessage:
        "Sorry, we couldn't find any results for your search terms.",
      emptySearchResultsForCategoryMessage:
        "Sorry, we couldn't find any results for your search terms in this category.",
    },
    StoryCarousel: {
      previousSlideButtonAriaLabel: 'Previous slide',
      nextSlideButtonAriaLabel: 'Next slide',
    },
  },
}
